import type { ItemMetaData } from '@mimir/common/dto/fieldValue';
import { SystemDefaultField } from '@mimir/common/mdf/mdfDefaults';
import { getBasenameWithoutExtension, getExtname } from '@mimir/common/platformAbstraction/pathComposition';

/**
 * Contructs filename for upload item using item's default_title mdf and given extension
 */
export const constructExportedSequenceFileName = (existingFilename: string, pathSep: string, itemMetadata: ItemMetaData | null, ext?: string) => {
  const existingExtension = getExtname(existingFilename, pathSep);
  let fileBaseName = getBasenameWithoutExtension(existingFilename, pathSep);
  const itemTitle = itemMetadata?.formData?.[SystemDefaultField.Title];
  if (itemTitle && fileBaseName !== itemTitle) {
    fileBaseName = itemTitle as string;
  } else if (!ext) {
    return existingFilename;
  }

  // Removing characters not allowed in file names on windows, linux and mac
  const cleanedFilename = fileBaseName.replace(/[\\|/:*?"<>]/g, '');
  const filename = cleanedFilename.length > 0 ? cleanedFilename : 'Exported sequence';
  if (ext) {
    if (!ext.startsWith('.')) {
      ext = '.' + ext;
    }
  } else {
    ext = existingExtension;
  }
  return `${filename}${ext}`;
};
